import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Button } from "../ui/button";
import { Trash2, CreditCard, Plus, Minus, ChevronDown, ReceiptText, MessageCircleMore, MessageSquare } from "lucide-react";
import { useState, useEffect, useRef, useMemo } from "react";
import { postRequest } from "../../services/mainApp.service";
import { useSelector } from "react-redux";
import { OrderPayment } from "./OrderPayment";
import { message, Popconfirm } from "antd";
import KotPrint from "../NewOrderComponents/Kot";
import OrderCheckoutBill from "../NewComponents/OrderCheckoutBill";
import OrderBill from "../NewComponents/OrderBill";
import useFeatureCheck from "../../customHooks/useFeatureCheck";
import { useLocation } from "react-router-dom";
import AuthLoginModal from "../../screens/POS/AuthLoginModal";
import { DiscountPopup } from "./DiscountPopup";
import { SpecialInstructionDialog } from "./SpecialInstructionDialog";
import { ProductDetailModal } from "./ProductDetailModal";
import { Textarea } from "../ui/textarea";
import { DeliveryChargesPopup } from "./DeliveryChargesPopup";
import { PaymentTermsPopup } from "./PaymentTermsPopup";
import { set } from "date-fns";
import { AGENT, CALL_CENTER_ADMIN } from "../../common/SetupMasterEnum";


export function OrderSummary({ orderType, items, onPayment, onRemoveItem, onClearAll, currentOrder
  , lastOrderId, onRecallOrder, setLastOrderId, onUpdateQuantity, isRecalledOrder, onResetRecalledOrder
  , DayShiftCounterData, OrderMasterId
  , orderKotItems, onUpdateDiscount, onUpdateSpecialInstruction, onUpdateItems
  , onCancelOrder, orderCancelReasons }) {

  const userData = useSelector((state) => state.authReducer);
  const location = useLocation();
  const checkFeatureAuth = useFeatureCheck();
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedTax, setSelectedTax] = useState(null);
  const [taxOptions, setTaxOptions] = useState([]);
  const [expandedItems, setExpandedItems] = useState({});
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [paymentModeList, setPaymentMode] = useState([]);
  const [dataForKotPrint, setDataForKotPrint] = useState(null);
  const [checkoutBillData, setCheckoutBillData] = useState(null);
  const checkoutBillRef = useRef(null);
  const [billData, setBillData] = useState(null);
  const orderBillRef = useRef(null);
  const [isAuthenticate, setIsAuthenticate] = useState(false);
  const [visibleAuthModal, setVisibleAuthModal] = useState(false);
  const [featureName, setFeatureName] = useState("");
  const [pendingAction, setPendingAction] = useState(null);
  const [pendingItemId, setPendingItemId] = useState(null);
  const [billCount, setBillCount] = useState(currentOrder?.BillPrintCount || 0);
  const [isDiscountPopupOpen, setIsDiscountPopupOpen] = useState(false);
  const [discountData, setDiscountData] = useState({});
  const [isSpecialInstructionDialogOpen, setIsSpecialInstructionDialogOpen] = useState(false);
  const [selectedItemForInstruction, setSelectedItemForInstruction] = useState(null);
  const [selectedItemForDiscount, setSelectedItemForDiscount] = useState(null);
  const [isProductDetailModalOpen, setIsProductDetailModalOpen] = useState(false);
  const [selectedProductForEdit, setSelectedProductForEdit] = useState(null);
  const { TerminalList, DayShiftCounter } = useSelector((state) => state.POSReducer);
  const [discountTypeFlex, setDiscountTypeFlex] = useState(null);
  const [openOrderPayment, setOpenOrderPayment] = useState(false);
  const [instruction, setInstruction] = useState("");
  const [isDeliveryChargesPopupOpen, setIsDeliveryChargesPopupOpen] = useState(false);
  const [selectedDeliveryCharges, setSelectedDeliveryCharges] = useState(null);
  const [isPaymentTermsPopupOpen, setIsPaymentTermsPopupOpen] = useState(false);
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);
  const [shouldCheckoutAfterPaymentTerm, setShouldCheckoutAfterPaymentTerm] = useState(false);

  const menuName = location.pathname.split("/").filter(Boolean).length ?
    location.pathname.split("/").filter(Boolean)[location.pathname.split("/").filter(Boolean).length - 1] :
    "OrderRecall";


  const currentOrderSnapshot = useMemo(() => {

    if (!currentOrder) return null;
    return Object.keys(currentOrder).reduce((acc, key) => {
      const value = currentOrder[key];
      if (!Array.isArray(value)) {
        acc[key] = value;
      }
      return acc;
    }, {});
  }, [currentOrder]);

  const buildKotOrderDetails = (detailInfo = {}, fallback = {}) => {
    const orderDateValue =
      detailInfo?.OrderDateTime ||
      detailInfo?.OrderDate ||
      fallback?.orderDate ||
      "";

    return {
      orderModeName:
        detailInfo?.OrderMode ||
        detailInfo?.OrderModeName ||
        fallback?.orderModeName ||
        fallback?.OrderMode ||
        fallback?.orderMode ||
        "N/A",
      customerName:
        detailInfo?.CustomerName ||
        detailInfo?.CustomerFullName ||
        fallback?.customerName ||
        fallback?.CustomerName ||
        "N/A",
      CompleteAddress:
        detailInfo?.CustomerAddress ||
        detailInfo?.CompleteAddress ||
        fallback?.CustomerAddress ||
        fallback?.CompleteAddress ||
        "",
      PhoneNumber:
        detailInfo?.PhoneNumber ||
        fallback?.PhoneNumber ||
        fallback?.phoneNumber ||
        "",
      AlternateNumber:
        detailInfo?.AlternateNumber || fallback?.AlternateNumber || "",
      LandMark: detailInfo?.LandMark || fallback?.LandMark || "",
      orderNumber:
        detailInfo?.OrderNumber ||
        fallback?.OrderNumber ||
        fallback?.orderNumber ||
        "",
      orderDate: orderDateValue || new Date().toISOString(),
    };
  };

  const prepareKotAddItems = (items = []) => {
    if (!Array.isArray(items) || items.length === 0) {
      return [];
    }

    const groupedByRandom = items.reduce((acc, item) => {
      const key =
        item.RandomId ??
        `${item.OrderDetailId || item.ProductDetailId}_${item.ProductDetailId}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});

    return Object.values(groupedByRandom).map((group) => {
      const parentRow =
        group.find(
          (row) =>
            row.DealItemId === null ||
            row.DealItemId === 0 ||
            row.DealItemId === "0"
        ) || group[0];

      const parentItem = {
        id:
          parentRow.RandomId ||
          `${parentRow.OrderDetailId || parentRow.ProductDetailId}`,
        quantity: parentRow.Quantity || 1,
        ProductDetailId: parentRow.ProductDetailId,
        name: parentRow.ProductDetailName || parentRow.ProductName,
        ProductName: parentRow.ProductDetailName || parentRow.ProductName,
        ProductDetailName: parentRow.ProductDetailName || parentRow.ProductName,
        SizeName: parentRow.SizeName,
        FlavourName: parentRow.FlavourName,
        DepartmentName:
          parentRow.DepartmentName ||
          parentRow.Department ||
          parentRow.DepartmentTitle ||
          "General",
        DepartmentId: parentRow.DepartmentId || null,
        SpecialInstructions: parentRow.SpecialInstructions || parentRow.SpecialInstruction || null,
        Comment: parentRow.Comment || parentRow.Comments || null,
        ItemLessReason: parentRow.ItemLessReason || parentRow.ItemLessReasonName || null,
        dealSelections: {},
      };

      group
        .filter(
          (row) =>
            row.DealItemId !== null &&
            row.DealItemId !== 0 &&
            row.DealItemId !== "0"
        )
        .forEach((row) => {
          const dealKey = row.DealItemId || `deal-${parentItem.id}`;
          if (!Array.isArray(parentItem.dealSelections[dealKey])) {
            parentItem.dealSelections[dealKey] = [];
          }
          parentItem.dealSelections[dealKey].push({
            name: row.ProductDetailName || row.ProductName,
            ProductDetailName: row.ProductDetailName || row.ProductName,
            Quantity: row.Quantity || 1,
            SizeName: row.SizeName,
            FlavourName: row.FlavourName,
            ItemLessReason: row.ItemLessReason || row.ItemLessReasonName || null,
            SpecialInstructions: row.SpecialInstructions || row.SpecialInstruction || null,
            Comment: row.Comment || row.Comments || null,
          });
        });

      return parentItem;
    });
  };

  const fetchOrderDetailForKot = async (orderId) => {
    if (!orderId) {
      return null;
    }

    const response = await postRequest("getOrderDetail", {
      OperationId: 1,
      CompanyId: userData.CompanyId,
      OrderId: orderId,
      UserId: userData.UserId,
      UserIP: userData.UserIP || "0.0.0.0",
    });

    if (response?.data?.DataSet) {
      return response.data.DataSet;
    }

    return null;
  };

  const DisplayCheckoutButton = () => {

    if (TerminalList && TerminalList.length > 0) {
      if (DayShiftCounter && Object.keys(DayShiftCounter).length > 0) {

        const SelectedTerminalId = DayShiftCounter?.filter(a => a.IsSelected == true)[0]?.TerminalId;

        const terminalObj = TerminalList?.find(a => a.TerminalId == SelectedTerminalId);

        if (terminalObj && terminalObj.Checkout == true) {

          return true;

        }
        return false;

      }
    }

  };

  useEffect(() => {


    const aa = DayShiftCounter;

    if (currentOrder && currentOrder?.Table11) {
      setTaxOptions(currentOrder?.Table11);

      if (currentOrder?.Table11?.length > 0) {
        setSelectedTax(currentOrder?.Table11[0]);
      }
    }

    if (currentOrder && currentOrder?.Table15) {
      setPaymentMode(currentOrder?.Table15);
    }

    if (currentOrder) {
      const orderInstruction =
        currentOrder.SpecialInstruction ||
        currentOrder.specialInstruction ||
        currentOrder.SpecialInstructions ||
        currentOrder.specialInstructions ||
        "";
      setInstruction(orderInstruction);
    } else {
      setInstruction("");
    }

    if (currentOrder && currentOrder.discountMaster !== undefined) {
      if (currentOrder && currentOrder.discountDetail !== undefined) {

        setDiscountData(
          {
            discountMaster: currentOrder.discountMaster,
            discountDetail: currentOrder.discountDetail
          }
        );
      }
      else {
        setDiscountData(
          {
            discountMaster: currentOrder.discountMaster,
            discountDetail: []
          }
        );
      }
    }

    // Initialize delivery charges from currentOrder
    if (currentOrder && currentOrder.deliveryCharges !== undefined) {
      setSelectedDeliveryCharges(parseFloat(currentOrder.deliveryCharges || 0));
    }

    // Initialize payment term from currentOrder
    if (currentOrder && currentOrder.paymentTerm !== undefined) {
      setSelectedPaymentTerm(currentOrder.paymentTerm);
    } else if (currentOrder && currentOrder.paymentTermId !== undefined && currentOrder.paymentTerms) {
      // If we have paymentTermId, find the matching term from paymentTerms array
      const matchingTerm = currentOrder.paymentTerms.find(
        term => term.PaymentTermId === currentOrder.paymentTermId
      );
      if (matchingTerm) {
        setSelectedPaymentTerm(matchingTerm);
      }
    }



  }, [currentOrder]);

  // Clear selected item for discount when items are cleared or the selected item is removed
  useEffect(() => {
    if (items.length === 0) {
      setSelectedItemForDiscount(null);
    } else if (selectedItemForDiscount && !items.find(item => item.id === selectedItemForDiscount.id)) {
      // Selected item was removed from items
      setSelectedItemForDiscount(null);
    }
  }, [items, selectedItemForDiscount]);

  useEffect(() => {
    if (checkoutBillData && checkoutBillData.orderDetails && checkoutBillData.orderItems && checkoutBillData.orderItems.length > 0) {
      // Use requestAnimationFrame to stay in user action context
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (checkoutBillRef.current) {
            try {
              checkoutBillRef.current.print();
            } catch (error) {
              console.error("Error printing checkout bill:", error);
            }
          }
        }, 500);
      });
    }
  }, [checkoutBillData]);

  useEffect(() => {
    if (billData && billData.orderDetails && billData.orderItems && billData.orderItems.length > 0) {
      // Use requestAnimationFrame to stay in user action context
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (orderBillRef.current) {
            try {
              orderBillRef.current.print();
            } catch (error) {
              console.error("Error printing order bill:", error);
            }
          }
        }, 500);
      });
    }
  }, [billData]);

  const toggleItemExpansion = (itemId) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  // Calculate subtotal BEFORE discount (using basePrice or original price)
  const subtotalBeforeDiscount = items.reduce((sum, item) => {
    const basePrice = parseFloat(item.price) || parseFloat(item.basePrice) || 0;
    const itemQuantity = parseInt(item.quantity) || 1;
    return sum + (basePrice * itemQuantity);
  }, 0);

  // Calculate total discount amount
  const totalDiscount = items.reduce((sum, item) => {
    const itemDiscount = parseFloat(item.discountAmount) || 0;

    // If discountAmount is not set but discountPercent is, calculate it
    if (!itemDiscount && item.discountPercent > 0) {
      const basePrice = parseFloat(item.basePrice) || parseFloat(item.price) || 0;
      const itemQuantity = parseInt(item.quantity) || 1;
      const itemTotalBeforeDiscount = basePrice * itemQuantity;
      const calculatedDiscount = (itemTotalBeforeDiscount * parseFloat(item.discountPercent)) / 100;
      return sum + calculatedDiscount;
    }
    return sum + itemDiscount;
  }, 0);

  // Calculate subtotal AFTER discount
  const subtotalAfterDiscount = subtotalBeforeDiscount - totalDiscount;

  // Calculate tax on discounted amount
  const taxableAmount = subtotalBeforeDiscount;
  const taxAmount = selectedTax ? (taxableAmount * parseFloat(selectedTax.GSTPercentage) / 100) : 0;

  // Use selected delivery charges if set, otherwise fall back to currentOrder.deliveryCharges
  const deliveryCharges =
    currentOrder?.orderModeName?.toLowerCase() === "delivery"
      ? (selectedDeliveryCharges !== null ? selectedDeliveryCharges : parseFloat(currentOrder.deliveryCharges || 0))
      : 0;

  // Calculate final total (discounted subtotal + tax)
  const total = subtotalBeforeDiscount + taxAmount + deliveryCharges;

  const totalBill = subtotalAfterDiscount + taxAmount + deliveryCharges;
  const canOpenDeliveryChargesPopup =
    !isProcessing &&
    items.length > 0 &&
    !!currentOrder &&
    currentOrder?.orderModeName?.toLowerCase() === "delivery";

  const handleCheckout = async (obj = {}, BtnKot = false, isDepartmentKot = false, isHold = false) => {

    if (!currentOrder || items.length === 0 || !selectedTax) {
      console.error("No order data, items to checkout, or tax not selected");
      return;
    }


    setIsProcessing(true);

    let orderDetails = [];
    let kotAddItemsArr = [];
    let kotLessItemsArr = [];

    const current_Order = { ...(currentOrderSnapshot || {}) };

    // const current_Order = { ...currentOrder };

    try {

      orderDetails = items.filter(a => a.OrderDetailId === undefined).flatMap(item => {
        const baseItem = {
          OrderMasterId: OrderMasterId || null,
          ProductDetailId: item.ProductDetailId,
          Quantity: item.quantity,
          PriceWithoutGST: item.basePrice ? item.basePrice.toString() : item.price.toString(),
          GSTId: selectedTax.GSTId,
          PriceWithGST: item.price.toString(),
          OrderParentId: null,
          SpecialInstruction: item.SpecialInstructions || null,
          DealItemId: null,
          DiscountPercent: item.discountPercent || 0,
          RandomId: Math.floor(Math.random() * 10000),
          IsTopping: false,
          HalfAndHalf: false,
          ProductPropertyId: null,
          DiscountId: item.discountPercent > 0 ?
            (currentOrder.Table14.find(d => d.ProductDetailId === item.ProductDetailId)?.DiscountId || 0)
            : 0,

        };

        if (item.dealSelections && Object.keys(item.dealSelections).length > 0) {
          const dealItems = [];

          Object.entries(item.dealSelections).forEach(([dealItemId, selection]) => {
            // Handle radio selections (single object)
            if (selection && !Array.isArray(selection)) {
              dealItems.push({
                ...baseItem,
                ProductDetailId: parseInt(selection.productDetailId),
                DealItemId: parseInt(dealItemId),
                DealDescId: parseInt(selection.id),
                IsTopping: true,
                PriceWithoutGST: selection.price.toString(),
                PriceWithGST: selection.price.toString(),
                Quantity: item.quantity,
              });
            }

            else if (Array.isArray(selection)) {
              selection.forEach(sel => {
                const optionQty = item.optionQuantities ?
                  (item.optionQuantities[`${dealItemId}-${sel.id}`] || 1) : 1;

                dealItems.push({
                  ...baseItem,
                  ProductDetailId: parseInt(sel.productDetailId),
                  DealItemId: parseInt(dealItemId),
                  DealDescId: parseInt(sel.id),
                  IsTopping: true,
                  PriceWithoutGST: sel.price.toString(),
                  PriceWithGST: sel.price.toString(),
                  Quantity: optionQty,
                });
              });
            }
          });

          return [baseItem, ...dealItems];
        }

        return [baseItem];
      });


      if (BtnKot) {

        if (orderKotItems && orderKotItems.length > 0) {

          let arr = orderKotItems.filter(a => a.IsKot == false);

          if (arr && arr.length > 0) {

            arr.forEach(item => {

              const newItem = {
                OrderMasterId: OrderMasterId || null,
                ProductDetailId: item.ProductDetailId,
                Quantity: item.quantity || 1,
                PriceWithoutGST: item.price,
                AmountWithoutGST: item.price
              };

              if (item.IsLess == false) {
                kotAddItemsArr.push(newItem);
              }
              else if (item.IsLess == true) {

                // Add ItemLessReasonId if it exists
                const lessItem = {
                  ...newItem,
                  ItemLessReasonId: item.ItemLessReasonId || null,
                  ItemLessReason: item.ItemLessReason || null,
                  OrderDetailId: item.OrderDetailId || null,
                };
                kotLessItemsArr.push(lessItem);
              }

              if (item.dealSelections && Object.keys(item.dealSelections).length > 0) {

                Object.values(item.dealSelections).forEach(dealItemsArray => {

                  dealItemsArray.forEach(deal_item => {
                    const newDealItem = {
                      OrderMasterId: OrderMasterId || null,
                      ProductDetailId: deal_item.productDetailId,
                      Quantity: deal_item.quantity || 1,
                      PriceWithoutGST: deal_item.price,
                      AmountWithoutGST: deal_item.price,
                      ProductDetailName: deal_item.name,
                    };
                    // kotAddItemsArr.push(newDealItem);

                    if (item.IsLess == false) {
                      kotAddItemsArr.push(newDealItem);
                    }
                    else if (item.IsLess == true) {
                      const newDealItemLess = {
                        ...newDealItem,
                        ItemLessReasonId: item.ItemLessReasonId || null,
                        ItemLessReason: item.ItemLessReason || null,
                      };

                      kotLessItemsArr.push(newDealItemLess);
                    }

                  });
                });
              }
            });

          }

        }
      }

      const kotLessItemsDetailString = kotLessItemsArr.filter(a => a.OrderDetailId != null && a.OrderDetailId != undefined && a.OrderDetailId != 0)
        .map(
          (i) =>
            `${i.Quantity ?? ""}||${i.ItemLessReasonId ?? ""}||${i.ItemLessReason ?? ""}||${i.OrderDetailId ?? ""}`
        )
        .join(",");

      const payload = {
        OperationId: isRecalledOrder ? 3 : 2,
        OrderMasterId: OrderMasterId || null,
        CompanyId: userData.CompanyId,
        BranchId: current_Order.branchId || null,
        AreaId: current_Order.areaId || null,
        CustomerId: current_Order.customerId,
        PhoneId: current_Order.phoneId,
        CustomerAddressId: current_Order.customerAddressId,
        RiderId: null,
        OrderStatusId: null,
        IsAdvanceOrder: false,
        SpecialInstruction: instruction || "",
        OrderDate: new Date().toISOString().split('T')[0],
        OrderTime: new Date().toTimeString().split(' ')[0],
        TotalAmountWithoutGST: subtotalBeforeDiscount.toFixed(2),
        GSTId: selectedTax.GSTId,
        TotalAmountWithGST: total.toFixed(2),
        UserIP: userData.UserIP,
        AlternateNumber: "",
        AdvanceOrderDate: null,
        DeliveryTime: 45,
        CLINumber: "",
        OrderSourceId: current_Order.orderSource,
        OrderSourceValue: current_Order.selectedOrderSourceName,
        DiscountId: 0,
        DeliveryCharges: deliveryCharges,
        PaymentTermId: currentOrder?.PaymentTermId || currentOrder?.paymentTermId || selectedPaymentTerm?.PaymentTermId || null,
        OrderCancelReasonId: null,
        WaiterId: current_Order.waiterId || null,
        ShiftDetailId: DayShiftCounterData?.ShiftDetailId ?? 0,
        CounterDetailId: DayShiftCounterData?.TerminalDetailId ?? 0,

        OrderModeId: current_Order.orderMode,
        Cover: current_Order.cover || 0,
        PaymentTypeId: selectedTax.PaymentModeId,
        DiscountAmount: totalDiscount.toFixed(2),
        GSTAmount: taxAmount.toFixed(2),
        CareOfId: null,
        BillPrintCount: 0,
        PreviousOrderMasterId: null,
        Remarks: "",
        DiscountPercent: 0,
        GSTPercent: selectedTax.GSTPercentage,
        FinishWasteRemarks: "",
        FinishWasteReasonId: null,
        UserId: userData.UserId,
        tblOrderDetail: orderDetails,
        TableId: current_Order.tableId || null,
        // tblOrderDetailAdd: (!isRecalledOrder ? kotAddItemsArr : orderAddItems) || [],
        tblOrderDetailAdd: kotAddItemsArr || [],
        tblOrderDetailLess: kotLessItemsArr || [],
        tblWebCustomerDetail: [],
        RedeemPoints: 0,
        TipAmount: obj?.info?.Tip ?? 0,
        ChangeAmount: "0.00",
        tblOrderExtraCharges: [],
        VoucherCode: null,
        VoucherAmount: null,
        VoucherId: null,
        tblOrderPaymentDetail: obj?.tblOrderPayment ?? [],
        CareOff: obj?.info?.CareOff,
        BankName: obj?.info?.BankName,
        CardNumber: obj?.info?.CardNumber,
        PartyPhoneId: obj?.partyAccountInfo?.PhoneId,
        PartyCustomerId: obj?.partyAccountInfo?.CustomerId,
        PartyPhoneNumber: obj?.partyAccountInfo?.PhoneNumber,
        PartyCustomerName: obj?.partyAccountInfo?.CustomerName,
        IsHold: isHold || false,
        ItemLessOrderDetailIds: kotLessItemsDetailString || null,
      };


      const response = await postRequest("CrudOrder", payload);

      if (response.data.Response) {

        const orderId =
          response?.data?.DataSet?.Table?.[0]?.Id ||
          OrderMasterId ||
          current_Order?.OrderMasterId ||
          null;

        const isNewOrder = !isRecalledOrder;

        if (BtnKot) {

          if (isDepartmentKot) {

            setDataForKotPrint({
              orderDetails: current_Order,
              orderAddItems: prepareKotAddItems(orderKotItems.filter(
                (a) => a.IsKot == false && a.IsLess == false
              )),
              orderLessItems: prepareKotAddItems(orderKotItems.filter(
                (a) => a.IsKot == false && a.IsLess == true
              )),
              addHeading: isNewOrder ? "KOT - New Order" : "KOT - Additional",
              groupByDepartment: true,
              departmentAddHeadingBase: isNewOrder ? "KOT - New Order" : "KOT - Additional",
              departmentLessHeadingBase: "KOT - Less",
            });

          } else {
            setDataForKotPrint({
              orderDetails: current_Order,
              orderAddItems: orderKotItems.filter(
                (a) => a.IsKot == false && a.IsLess == false
              ),
              orderLessItems: orderKotItems.filter(
                (a) => a.IsKot == false && a.IsLess == true
              ),
              addHeading: isNewOrder ? "KOT - New Order" : "KOT - Additional",
              groupByDepartment: false,
            });
          }
        } else {
          message.success("Order placed successfully!");
          if (orderId) {
            localStorage.setItem('lastOrderId', orderId.toString());
            setLastOrderId(orderId);
          }
          if (isRecalledOrder && onResetRecalledOrder) {
            onResetRecalledOrder();
          }

          console.log("Checkout Order Details:", orderDetails);
          onClearAll();
        }
      } else {
        console.error("Failed to create order:", response.data);
        message.error("Failed to place order. Please try again.");
      }
    } catch (error) {
      console.error("Error during checkout:", error);
      message.error("An error occurred during checkout. Please try again.");
    } finally {
      setIsProcessing(false);

      if (BtnKot) {
        onClearAll();
      }

      if (obj?.tblOrderPayment) {
        setCheckoutBillData(
          {
            orderDetails: current_Order,
            orderItems: orderKotItems,
            paymentDetails: obj?.tblOrderPayment,
            paymentDetailsInfo: obj?.info,
            paymentDetailsPartyAccountInfo: obj?.partyAccountInfo,
          }
        );

      }
    };
  }

  const handlePaymentButtonClick = () => {

    if (userData?.RoleId != AGENT) {
      const hasItemsWithIsKotFalse = orderKotItems.some(item => item.IsKot === false);
      if (hasItemsWithIsKotFalse) {
        message.warning("Please Generate Kot First");
        setIsPaymentModalOpen(false);
        return;
      }
    }
    setIsPaymentModalOpen(true);
  };

  const handleIncreaseQuantity = (itemId) => {

    const item = items.find(item => item.id === itemId);
    if (item) {
      onUpdateQuantity(itemId, item.quantity + 1);
    }
  };

  const handleItemDecreaseFlow = (itemId, isRemoveRow = false) => {

    const item = items.find(item => item.id === itemId);
    if (item) {
      if (isRemoveRow == false) {
        if (item.quantity > 1) {
          onUpdateQuantity(itemId, item.quantity - 1);
        } else {
          onUpdateQuantity(itemId, 0);
        }
      }
      else {
        // setIsRemoveRow(false);
        onUpdateQuantity(itemId, 0);
      }
    }
  };

  const handleAuthSuccess = () => {

    setIsAuthenticate(true);
    setVisibleAuthModal(false);

    if ((pendingAction === "ITEM_LESS_BEFORE_BILL" || pendingAction === "ITEM_LESS_AFTER_BILL") && pendingItemId) {
      handleItemDecreaseFlow(pendingItemId);
    } else if (pendingAction === "DISCOUNT") {
      handleDiscountPopupFlow();
    } else if (pendingAction === "REMOVE_DISCOUNT") {
      handleRemoveDiscountFlow();
    }

    setPendingAction(null);
    setPendingItemId(null);
    setIsAuthenticate(false);
  };

  const handleDecreaseQuantity = (itemId, isRemoveRow = false) => {

    const item = orderKotItems.find(item => item.id === itemId);

    if (item && item.IsKot === false) {
      handleItemDecreaseFlow(itemId, isRemoveRow);
      return;
    }

    const billPrintCount = billCount;
    const isBillPrinted = billPrintCount > 0;

    const featureKey = isBillPrinted ? "ITEM_LESS_AFTER_BILL" : "ITEM_LESS_BEFORE_BILL";
    setFeatureName(featureKey);
    setPendingAction(featureKey);
    setPendingItemId(itemId);

    if (isAuthenticate) {
      handleItemDecreaseFlow(itemId, isRemoveRow);
      setIsAuthenticate(false);
      setPendingAction(null);
      setPendingItemId(null);
      return;
    }

    const hasPermission = checkFeatureAuth(featureKey, undefined, { showErrorMessage: false });

    if (!hasPermission) {
      setVisibleAuthModal(true);
      return;
    }

    handleItemDecreaseFlow(itemId, isRemoveRow);
    setPendingAction(null);
    setPendingItemId(null);
  };

  const getTaxByType = (type) => {
    if (!taxOptions || taxOptions.length === 0) {
      return null;
    }

    if (type === "cash") {
      return taxOptions.find((tax) => tax.IsCashType);
    }

    if (type === "card") {
      return taxOptions.find((tax) => tax.IsCreditType);
    }

    return null;
  };

  const handleBillPrint = ({ paymentModeLabel, taxType }) => {

    if (userData?.RoleId != AGENT) {
      const hasItemsWithIsKotFalse = orderKotItems.some(item => item.IsKot === false);
      if (hasItemsWithIsKotFalse) {
        message.warning("Please Generate Kot First");
        return;
      }
    }

    if (!items || items.length === 0 || !currentOrderSnapshot) {
      message.error("No order data available to print the bill.");
      return;
    }

    // Handle Bill-Both case - single print with two sections
    if (paymentModeLabel === "Cash & Card" || taxType === "both") {
      const cashTax = getTaxByType("cash");
      const cardTax = getTaxByType("card");

      if (!cashTax || !cardTax) {
        message.error("Both Cash and Card tax options are required for Bill-Both.");
        return;
      }

      // Calculate bill amounts with discount (same for both)
      const subtotalBeforeDiscountForBill = items.reduce((sum, item) => {
        const basePrice = parseFloat(item.basePrice) || parseFloat(item.price) || 0;
        const itemQuantity = parseInt(item.quantity) || 1;

        const subTotalDealOptions = item.dealSelections ? Object.entries(item.dealSelections).reduce((sum_Deal, [dealItemId, selection]) => {
          if (!selection) return sum_Deal;

          // Handle single object (radio selection)
          if (!Array.isArray(selection)) {
            return sum_Deal + (parseFloat(selection.price) || 0) * itemQuantity;
          }

          // Handle array (checkbox selections)
          return sum_Deal + selection.reduce((selSum, sel) => {
            const qtyKey = `${dealItemId}-${sel.id}`;
            const qty = item.optionQuantities ? (item.optionQuantities[qtyKey] || 1) : 1;
            return selSum + (parseFloat(sel.price) || 0) * qty;
          }, 0);
        }, 0) : 0;

        return sum + (basePrice * itemQuantity) + subTotalDealOptions;
      }, 0);

      const totalDiscountForBill = items.reduce((sum, item) => {
        const itemDiscount = parseFloat(item.discountAmount) || 0;
        if (!itemDiscount && item.discountPercent > 0) {
          const basePrice = parseFloat(item.basePrice) || parseFloat(item.price) || 0;
          const itemQuantity = parseInt(item.quantity) || 1;
          const itemTotalBeforeDiscount = basePrice * itemQuantity;
          const calculatedDiscount = (itemTotalBeforeDiscount * parseFloat(item.discountPercent)) / 100;
          return sum + calculatedDiscount;
        }
        return sum + itemDiscount;
      }, 0);

      const subtotalAfterDiscountForBill = subtotalBeforeDiscountForBill - totalDiscountForBill;

      // Calculate Cash section
      const cashTaxPercent = parseFloat(cashTax?.GSTPercentage) || 0;
      const cashTaxAmount = subtotalAfterDiscountForBill * cashTaxPercent / 100;
      const cashTotal = subtotalAfterDiscountForBill + cashTaxAmount;

      // Calculate Card section
      const cardTaxPercent = parseFloat(cardTax?.GSTPercentage) || 0;
      const cardTaxAmount = subtotalAfterDiscountForBill * cardTaxPercent / 100;
      const cardTotal = subtotalAfterDiscountForBill + cardTaxAmount;

      const printItems = orderKotItems && orderKotItems.length > 0 ? orderKotItems : items;

      if (!printItems.length) {
        message.error("No items available to print the bill.");
        return;
      }



      // Create bill with both sections
      const billOrderDetails = {
        ...currentOrderSnapshot,
        TotalAmountWithoutGST: subtotalBeforeDiscountForBill.toFixed(2),
        TotalGST: cashTaxAmount.toFixed(2), // Default to cash for backward compatibility
        NetAmount: cashTotal.toFixed(2),
        TotalAmountWithGST: cashTotal.toFixed(2),
        DeliveryCharges: 0,
        discountAmount: totalDiscountForBill.toFixed(2),
        Discount: totalDiscountForBill.toFixed(2), // Keep for backward compatibility
        PaymentMode: "Cash & Card",
        PaymentDate: new Date().toISOString(),
        GSTPercentage: cashTax?.GSTPercentage,
        GSTId: cashTax?.GSTId,
        // Add both sections data
        isBothBill: true,
        cashSection: {
          GSTPercentage: cashTax?.GSTPercentage,
          GSTId: cashTax?.GSTId,
          TotalGST: cashTaxAmount.toFixed(2),
          NetAmount: cashTotal.toFixed(2),
          TotalAmountWithGST: cashTotal.toFixed(2),
        },
        cardSection: {
          GSTPercentage: cardTax?.GSTPercentage,
          GSTId: cardTax?.GSTId,
          TotalGST: cardTaxAmount.toFixed(2),
          NetAmount: cardTotal.toFixed(2),
          TotalAmountWithGST: cardTotal.toFixed(2),
        },
      };

      setBillData({
        orderDetails: billOrderDetails,
        orderItems: printItems,
      });

      return;
    }

    // Handle single bill (Cash or Card)
    const targetTax = taxType ? getTaxByType(taxType) : selectedTax;

    if (!targetTax) {
      message.error("Required tax option is missing for this bill.");
      return;
    }

    if (!selectedTax || selectedTax?.GSTId !== targetTax.GSTId) {
      setSelectedTax(targetTax);
    }

    // Calculate bill amounts with discount
    const subtotalBeforeDiscountForBill = items.reduce((sum, item) => {
      const basePrice = parseFloat(item.basePrice) || parseFloat(item.price) || 0;
      const itemQuantity = parseInt(item.quantity) || 1;
      const subTotalDealOptions = item.dealSelections ? Object.entries(item.dealSelections).reduce((sum_Deal, [dealItemId, selection]) => {
        if (!selection) return sum_Deal;

        // Handle single object (radio selection)
        if (!Array.isArray(selection)) {
          return sum_Deal + (parseFloat(selection.price) || 0) * itemQuantity;
        }

        // Handle array (checkbox selections)
        return sum_Deal + selection.reduce((selSum, sel) => {
          const qtyKey = `${dealItemId}-${sel.id}`;
          const qty = item.optionQuantities ? (item.optionQuantities[qtyKey] || 1) : 1;
          return selSum + (parseFloat(sel.price) || 0) * qty;
        }, 0);
      }, 0) : 0;

      return sum + (basePrice * itemQuantity) + subTotalDealOptions;
    }, 0);


    const totalDiscountForBill = items.reduce((sum, item) => {
      const itemDiscount = parseFloat(item.discountAmount) || 0;
      if (!itemDiscount && item.discountPercent > 0) {
        const basePrice = parseFloat(item.basePrice) || parseFloat(item.price) || 0;
        const itemQuantity = parseInt(item.quantity) || 1;
        const itemTotalBeforeDiscount = basePrice * itemQuantity;
        const calculatedDiscount = (itemTotalBeforeDiscount * parseFloat(item.discountPercent)) / 100;
        return sum + calculatedDiscount;
      }
      return sum + itemDiscount;
    }, 0);

    const subtotalAfterDiscountForBill = subtotalBeforeDiscountForBill - totalDiscountForBill;
    const taxPercent = parseFloat(targetTax?.GSTPercentage) || 0;
    const taxAmountForBill = subtotalAfterDiscountForBill * taxPercent / 100;
    const totalForBill = subtotalAfterDiscountForBill + taxAmountForBill;

    const billOrderDetails = {
      ...currentOrderSnapshot,
      TotalAmountWithoutGST: subtotalBeforeDiscountForBill.toFixed(2),
      TotalGST: taxAmountForBill.toFixed(2),
      NetAmount: totalForBill.toFixed(2),
      TotalAmountWithGST: totalForBill.toFixed(2),
      DeliveryCharges: 0,
      discountAmount: totalDiscountForBill.toFixed(2),
      Discount: totalDiscountForBill.toFixed(2), // Keep for backward compatibility
      PaymentMode: paymentModeLabel || targetTax?.PaymentMode || "N/A",
      PaymentDate: new Date().toISOString(),
      GSTPercentage: targetTax?.GSTPercentage,
      GSTId: targetTax?.GSTId,
      isBothBill: false,
    };

    const printItems = orderKotItems && orderKotItems.length > 0 ? orderKotItems : items;

    if (!printItems.length) {
      message.error("No items available to print the bill.");
      return;
    }

    setBillData({
      orderDetails: billOrderDetails,
      orderItems: printItems,
    });
  };

  // Internal function to handle opening discount popup
  const handleDiscountPopupFlow = () => {
    setIsDiscountPopupOpen(true);

  };

  // Internal function to handle removing discount
  const handleRemoveDiscountFlow = async () => {
    if (!items || items.length === 0 || !onUpdateDiscount) {
      return;
    }

    const updatedItems = items.map(item => ({
      ...item,
      discountPercent: 0,
      discountAmount: 0,
      discountId: null
    }));

    onUpdateDiscount(updatedItems);

    if (currentOrder?.OrderMasterId) {
      await applyDiscountApi(null, currentOrder.OrderMasterId, "", "");
    }
  };

  // Public function with authentication check for Discount button
  const handleDiscountPopup = (discountTypeFlex, openFromOrderPayment = false) => {

    if (userData.RoleId != AGENT) {
      // Check if there are any items with IsKot = false for BILL_DISCOUNT_POS
      if (discountTypeFlex === "BILL_DISCOUNT_POS") {
        const hasItemsWithIsKotFalse = orderKotItems.some(item => item.IsKot === false);
        if (hasItemsWithIsKotFalse) {
          message.warning("Please Generate Kot First");
          return;
        }
      }

      // Check if selected item has IsKot = false for ITEM_DISCOUNT_POS
      if (discountTypeFlex === "ITEM_DISCOUNT_POS") {
        if (selectedItemForDiscount) {
          // Check in orderKotItems first, then fallback to items
          const itemInKot = orderKotItems.find(item => item.id === selectedItemForDiscount.id);
          const itemToCheck = itemInKot || selectedItemForDiscount;

          if (itemToCheck.IsKot === false) {
            message.warning("Please Generate Kot First");
            return;
          }
        }
      }
    }

    setDiscountTypeFlex(discountTypeFlex);
    const featureKey = "DISCOUNT";
    setFeatureName(featureKey);
    setPendingAction("DISCOUNT");

    if (openFromOrderPayment) {
      setOpenOrderPayment(true);
    }
    else {
      setOpenOrderPayment(false);
    }

    if (isAuthenticate) {
      handleDiscountPopupFlow();
      setIsAuthenticate(false);
      setPendingAction(null);
      return;
    }

    const hasPermission = checkFeatureAuth(featureKey, undefined, { showErrorMessage: false });

    if (!hasPermission) {
      setVisibleAuthModal(true);
      return;
    }

    handleDiscountPopupFlow();
    setPendingAction(null);


  };

  // Public function with authentication check for Remove Discount button
  // This is called when user confirms in Popconfirm
  const handleRemoveDiscount = () => {
    const featureKey = "REMOVE_DISCOUNT";
    setFeatureName(featureKey);
    setPendingAction("REMOVE_DISCOUNT");

    // If already authenticated (from previous auth modal), execute immediately
    if (isAuthenticate) {
      handleRemoveDiscountFlow();
      setIsAuthenticate(false);
      setPendingAction(null);
      setPendingItemId(null);
      return;
    }

    // Check if user has permission
    const hasPermission = checkFeatureAuth(featureKey, undefined, { showErrorMessage: false });

    if (!hasPermission) {
      // Show auth modal - after authentication, handleAuthSuccess will call handleRemoveDiscountFlow
      setVisibleAuthModal(true);
      return;
    }

    // User has permission, execute remove discount
    handleRemoveDiscountFlow();
    setPendingAction(null);
    setPendingItemId(null);
  };

  const handleApplyDiscount = async (updatedItems, discountId, careOf, description) => {
    onUpdateDiscount(updatedItems);

    if (discountTypeFlex === "ITEM_DISCOUNT_POS") {
      await applyDiscountApi(discountId, currentOrder.OrderMasterId, careOf, description, updatedItems[0]?.OrderDetailId);
    }
    else {
      await applyDiscountApi(discountId, currentOrder.OrderMasterId, careOf, description);
    }

    setIsDiscountPopupOpen(false);
    setSelectedItemForDiscount(null);

    if (openOrderPayment) {
      setIsPaymentModalOpen(true);
    }
    else {
      setIsPaymentModalOpen(false);
    }
  };

  const handleDoubleClickItem = (item) => {
    // Check if the item has already been printed (IsKot = true)
    // Check in orderKotItems first, then fallback to item.IsKot
    const kotItem = orderKotItems?.find(kotItem => kotItem.id === item.id);
    const isKotPrinted = kotItem?.IsKot === true || item?.IsKot === true;

    if (isKotPrinted) {
      message.warning("Cannot edit item that has already been printed in KOT.");
      return;
    }

    // Check if item is a deal by checking if it has dealSelections or by checking the product in currentOrder
    const hasDealSelections = item.dealSelections && Object.keys(item.dealSelections).length > 0;

    // Also check if the product itself is a deal from currentOrder.Table
    let isDeal = hasDealSelections;
    if (!isDeal && currentOrder && currentOrder.Table) {
      const tableProduct = currentOrder.Table.find(
        p => p.ProductId === item.ProductId || p.ProductDetailId === item.ProductDetailId
      );
      if (tableProduct && tableProduct.IsDeal) {
        isDeal = true;
      }
    }

    if (isDeal) {
      // Open ProductDetailModal for deal items
      setSelectedProductForEdit(item);
      setIsProductDetailModalOpen(true);
    } else {
      // Open special instruction dialog for non-deal items
      setSelectedItemForInstruction(item);
      setIsSpecialInstructionDialogOpen(true);
    }
  };

  const handleSaveSpecialInstruction = (itemId, instruction) => {
    if (onUpdateSpecialInstruction) {
      onUpdateSpecialInstruction(itemId, instruction);
    } else {
      // Fallback: Update items locally if no callback is provided
      // This won't persist if items are managed by parent, but will work for display
      message.warning("Special instruction updated locally. Please implement onUpdateSpecialInstruction callback in parent component.");
    }
  };

  const applyDiscountApi = async (discountId, orderMasterId, careOf, description, orderDetailId = null) => {
    // Implement API call to apply discount by ID if needed

    try {
      if (orderMasterId > 0) {
        const response = await postRequest(`ApplyDiscount`, {
          OperationId: discountId != null ? 1 : 2,
          CompanyId: userData.CompanyId,
          OrderMasterId: orderMasterId,
          DiscountId: discountId,
          CareOf: careOf || "",
          Description: description || "",
          OrderDetailId: orderDetailId || null
        });

        if (response.data.Response) {

          if (response?.error === true) {
            message.error(response?.errorMessage);
            return;
          }
          if (response?.data?.response === false) {
            message.error(response?.DataSet?.Table?.errorMessage);
            return;
          }
          message.success(response.successMessage);

        }
      }

    } catch (error) {
      console.error("Error recalling order:", error);
      alert("An error occurred while recalling the order");
    }
  };

  const handleApplyDeliveryCharges = (amount) => {
    setSelectedDeliveryCharges(amount);
    if (currentOrder) {
      currentOrder.deliveryCharges = amount;
    }
    message.success(`Delivery charges set to Rs ${amount}`);
  };

  const handleApplyPaymentTerm = (paymentTerm, shouldCheckout = false) => {

    setSelectedPaymentTerm(paymentTerm);

    // Set PaymentTermId in currentOrder
    if (currentOrder) {
      if (paymentTerm) {
        currentOrder.PaymentTermId = paymentTerm.PaymentTermId;
        currentOrder.paymentTermId = paymentTerm.PaymentTermId;
        currentOrder.paymentTerm = paymentTerm;
        message.success(`Payment term set to ${paymentTerm.PaymentTermName || paymentTerm.PaymentTerm || 'Selected'}`);
      } else {
        currentOrder.PaymentTermId = null;
        currentOrder.paymentTermId = null;
        currentOrder.paymentTerm = null;
        message.success("Payment term removed");
      }
    } else {
      if (paymentTerm) {
        message.success(`Payment term set to ${paymentTerm.PaymentTermName || paymentTerm.PaymentTerm || 'Selected'}`);
      } else {
        message.success("Payment term removed");
      }
    }

    // If this was triggered from Save Order button, call handleCheckout after setting payment term
    if (shouldCheckout) {
      setShouldCheckoutAfterPaymentTerm(false);
      // Small delay to ensure state is updated
      setTimeout(() => {
        handleCheckout({}, true);
      }, 100);
    }
  };

  const updateTableWaiterRiderApi = async (orderMasterId, operationId) => {


    if (orderMasterId > 0) {
      postRequest("/UpdateCoverWaiterRider", {
        OperationId: operationId,
        CompanyId: userData.CompanyId,
        UserId: userData.UserId,
        UserIP: "1.2.2.1",
        OrderMasterId: orderMasterId,

      })
        .then(async (response) => {
          if (response?.error === true) {
            message.error(response?.errorMessage);
            return;
          }
          if (response?.data?.response === false) {
            message.error(response?.DataSet?.Table?.errorMessage);
            return;
          }
          message.success(response.successMessage);
        })
        .catch((error) => { });
    }

  };

  return (
    <div className="w-[40rem] bg-background border-l border-border h-full flex flex-col">
      <div className="p-4 border-b border-border bg-primary text-primary-foreground rounded-t-lg">
        <div className="flex items-center gap-2">
          <span className="text-sm">Qty</span>
          {/* <Button
            onClick={onRecallOrder}
            disabled={!lastOrderId || isProcessing}
            variant="secondary"
            className="text-xs">
            RECALL
          </Button> */}
          <span className="text-sm ml-auto">Price</span>
        </div>
      </div>

      {/* Main Content: Table and Buttons Side by Side */}
      <div className="flex-1 flex flex-row overflow-hidden">
        {/* Order Items - Left Side */}
        <div className="flex-1 flex flex-col overflow-hidden">
          <div className="flex-1 overflow-y-auto p-4">
            {items.length === 0 ? (
              <p className="text-muted-foreground text-sm text-center py-8">No items selected</p>
            ) : (
              items.map((item) => {

                const itemTotal = (item.price || item.basePrice || 0) * (item.quantity || 1);
                const itemDiscount = item.discountAmount || 0;
                const itemPriceBeforeDiscount = (item.basePrice || 0) * (item.quantity || 1);
                const hasDealItems = item.dealSelections && Object.keys(item.dealSelections).length > 0;
                const isExpanded = expandedItems[item.id];

                // const kotItem = orderKotItems?.find(kotItem => kotItem.IsKot === false &&
                // kotItem.ProductDetailId === item.ProductDetailId);
                // const isOrderKotItem = (kotItem?.IsKot == false || kotItem == undefined) ? false : true;

                const kotItem = orderKotItems?.filter(kotItem => kotItem.ProductDetailId === item.ProductDetailId);
                const isOrderKotItem = kotItem?.every(item => userData?.RoleId === AGENT ? item.IsSent === true : item.IsKot === true);
                const isSelectedForDiscount = selectedItemForDiscount?.id === item.id;



                return (
                  <div
                    key={item.id}
                    className={`flex items-center justify-between py-2 border-b border-border cursor-pointer hover:bg-muted/50 transition-colors ${isSelectedForDiscount ? 'bg-blue-100 border-blue-500' : ''} ${isOrderKotItem ? 'bg-green-100' : ''}`}
                    onClick={() => {
                      if (isSelectedForDiscount) {
                        setSelectedItemForDiscount(null);
                      } else {
                        setSelectedItemForDiscount(item);
                      }
                    }}
                  // onDoubleClick={() => handleDoubleClickItem(item)}
                  // title="Click to select for item discount, Double-click to edit special instructions"
                  >
                    <div className="flex-1">
                      <div className="flex items-center">
                        <p className="text-xs font-medium">{item.name} </p>
                        {/* <p> {item.IsKot ? ' = true' : ' = false'} </p> */}

                        {hasDealItems && (
                          <Button
                            variant="ghost"
                            size="sm"
                            className="p-1 h-6 w-6 ml-2"
                            onClick={() => toggleItemExpansion(item.id)}>
                            <ChevronDown
                              className={`h-3 w-3 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}
                            />
                          </Button>
                        )}
                      </div>

                      {item.discountPercent > 0 && (
                        <p className="text-xs text-green-600">
                          Discount: {item.discountPercent}% (Save: Rs{itemDiscount.toFixed(2)})
                        </p>
                      )}

                      {item.SizeName && item.SizeName !== "-" && (
                        <p className="text-xs text-muted-foreground">Size: {item.SizeName}</p>
                      )}
                      {item.FlavourName && item.FlavourName !== "-" && (
                        <p className="text-xs text-muted-foreground">Flavor: {item.FlavourName}</p>
                      )}

                      {hasDealItems && (
                        <div className="mt-0">
                          <p className="text-xs text-muted-foreground">
                            {Object.keys(item.dealSelections).length} deal item(s)
                          </p>

                          {/* Collapsible deal items section */}
                          <div
                            className={`overflow-hidden transition-all duration-300 ease-in-out ${isExpanded ? 'max-h-96' : 'max-h-0'}`}>
                            <div className="mt-1 space-y-1">
                              {Object.entries(item.dealSelections).map(([dealItemId, selection]) => (
                                <div key={dealItemId} className="text-xs text-muted-foreground ml-2">
                                  {selection && !Array.isArray(selection) && (
                                    <span>
                                      • {selection.name}
                                      {selection.price > 0 && (
                                        <> (Rs {selection.price.toFixed(2)})</>
                                      )}
                                    </span>
                                  )}

                                  {Array.isArray(selection) && selection.map(sel => {
                                    const qtyKey = `${dealItemId}-${sel.id}`;
                                    const qty = item.optionQuantities ? (item.optionQuantities[qtyKey] || 1) : 1;
                                    const total = (sel.price || 0) * qty;

                                    return (
                                      <div key={sel.id}>
                                        • {sel.name} (x{qty})
                                        {sel.price > 0 && (
                                          <> - Rs {total.toFixed(2)}</>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                      {item.SpecialInstructions && (
                        <p className="text-xs text-muted-foreground">
                          Instructions: {item.SpecialInstructions}
                        </p>
                      )}
                    </div>

                    <div className="flex items-center gap-2">
                      <div className="flex items-center border rounded-md mr-2">
                        <Button
                          variant="ghost"
                          size="xs"
                          className="p-1 h-6 w-6"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedItemForInstruction(item);
                            setIsSpecialInstructionDialogOpen(true);
                          }}>
                          <MessageCircleMore className="h-3 w-3" />
                        </Button>
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div className="flex items-center border rounded-md mr-2">
                        <Button
                          variant="ghost"
                          size="xs"
                          className="p-1 h-6 w-6"
                          onClick={() => handleDecreaseQuantity(item.id)}>
                          <Minus className="h-3 w-3" />
                        </Button>
                        <span className="px-2 text-xs">{item.quantity}</span>

                        {!item.OrderDetailId && (
                          <Button
                            variant="ghost"
                            size="xs"
                            className="p-1 h-6 w-6"
                            onClick={() => handleIncreaseQuantity(item.id)}>
                            <Plus className="h-3 w-3" />
                          </Button>
                        )}

                      </div>

                      <p className="text-xs font-medium">Rs{item.discountPercent > 0 ?
                        (itemTotal - item.discountAmount).toFixed(2) :
                        itemTotal.toFixed(2)}</p>

                      <Button
                        variant="ghost"
                        size="sm"
                        className="p-1 h-6 w-6"
                        onClick={() => {
                          // setIsRemoveRow(true);
                          handleDecreaseQuantity(item.id, true);
                        }}>
                        <Trash2 className="h-3 w-3" />
                      </Button>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          <div className="space-y-2">
            <Textarea
              id="instruction"
              placeholder="Enter special instructions"
              value={instruction}
              onChange={(e) => setInstruction(e.target.value)}
              rows={1}
              className="resize-none"
            />
          </div>

          {/* Totals Section */}
          <div className="p-4 border-t border-border space-y-3 flex-shrink-0">
            <div className="flex justify-between text-sm">
              <span>Sub Total</span>
              <span>Rs{subtotalBeforeDiscount.toFixed(2)}</span>
            </div>



            {/* Tax Selection - Only show if GST > 0 */}
            {selectedTax && parseFloat(selectedTax.GSTPercentage) > 0 && taxOptions.length > 0 && (
              <div className="space-y-2">
                <Select
                  value={selectedTax ? selectedTax.GSTId.toString() : ""}
                  onValueChange={(value) => {
                    const tax = taxOptions.find(t => t.GSTId.toString() === value);
                    if (tax) setSelectedTax(tax);
                  }}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select tax type" />
                  </SelectTrigger>
                  <SelectContent>
                    {taxOptions
                      .filter(a => a.ParentGstId == null)
                      .map((tax) => (
                        <SelectItem key={tax.GSTId} value={tax.GSTId.toString()}>
                          {tax.PaymentMode} - {tax.GSTPercentage}%
                        </SelectItem>
                      ))}
                  </SelectContent>
                </Select>
              </div>
            )}

            {/* Tax Amount - Only show if GST > 0 */}
            {selectedTax && parseFloat(selectedTax.GSTPercentage) > 0 && (
              <div className="flex justify-between text-sm">
                <span>Tax({selectedTax ? `${selectedTax.GSTPercentage}%` : 'VAT'})</span>
                <span>Rs{taxAmount.toFixed(2)}</span>
              </div>
            )}

            {currentOrder && currentOrder.orderMode == 111 && (
              <div className="flex justify-between text-sm">
                <span
                  role="button"
                  tabIndex={canOpenDeliveryChargesPopup ? 0 : -1}
                  onClick={() => {
                    if (canOpenDeliveryChargesPopup) {
                      setIsDeliveryChargesPopupOpen(true);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (canOpenDeliveryChargesPopup && (e.key === "Enter" || e.key === " ")) {
                      e.preventDefault();
                      setIsDeliveryChargesPopupOpen(true);
                    }
                  }}
                  className={canOpenDeliveryChargesPopup ? "cursor-pointer hover:underline" : ""}
                >
                  Delivery Charges
                </span>
                <span>Rs{deliveryCharges.toFixed(2)}</span>
              </div>
            )}

            {totalDiscount > 0 && <>
              <div className="flex justify-between text-sm">
                <span>Discount:</span>
                <span>Rs{totalDiscount.toFixed(2)}</span>
              </div>
            </>}
            <div className="flex justify-between font-semibold">
              <span>Total Bill:</span>
              <span>Rs{totalBill.toFixed(2)}</span>
            </div>
          </div>
        </div>

        {/* Buttons Section - Right Side */}
        <div className="w-32 border-l border-border p-2 flex flex-col gap-2 overflow-y-auto flex-shrink-0">
          {userData?.RoleId == AGENT && (
            <>
              <Button
                onClick={() => {
                  // Open payment terms popup first, then call handleCheckout after selection
                  setShouldCheckoutAfterPaymentTerm(true);
                  setIsPaymentTermsPopupOpen(true);
                }}
                disabled={isProcessing || items.length === 0 || !currentOrder || !selectedTax}
                className="w-full w-24 h-20 aspect-square bg-primary hover:bg-primary text-white flex flex-col items-center justify-center gap-1 text-xs">
                {isProcessing ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    Processing...
                  </>
                ) : (
                  <>
                    <CreditCard className="h-4 w-4" />
                    SAVE ORDER
                  </>
                )}
              </Button>

              <Popconfirm
                title="Clear All"
                description="Are you sure to clear all?"
                onConfirm={onClearAll}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  variant="destructive"
                  className="w-full w-24 h-20 aspect-square text-white flex flex-col items-center justify-center gap-1 text-xs">
                  <Trash2 className="h-4 w-4" />
                  CLEAR
                </Button>
              </Popconfirm>

              <Button
                onClick={() => handleDiscountPopup("BILL_DISCOUNT_POS")}
                disabled={isProcessing || items.length === 0 || !currentOrder || selectedItemForDiscount !== null}
                className="w-full w-24 h-20 aspect-square bg-gray-600 hover:bg-gray-700 text-white flex flex-col items-center justify-center gap-1 text-xs">
                DISCOUNT
              </Button>

              <Button
                onClick={() => setIsDeliveryChargesPopupOpen(true)}
                disabled={isProcessing || items.length === 0 || !currentOrder || currentOrder?.orderModeName?.toLowerCase() !== "delivery"}
                className={`w-full w-24 h-20 aspect-square ${deliveryCharges > 0 ? "bg-primary hover:bg-primary" : "bg-gray-600 hover:bg-gray-700"} text-white flex flex-col items-center justify-center gap-1 text-xs`}>
                DELIVERY
              </Button>

              {/* <Button
                onClick={() => setIsPaymentTermsPopupOpen(true)}
                // disabled={isProcessing || items.length === 0 || !currentOrder || !currentOrder?.paymentTerms || currentOrder?.paymentTerms?.length === 0}
                className={`w-full w-24 h-20 aspect-square ${selectedPaymentTerm ? "bg-primary hover:bg-primary" : "bg-gray-600 hover:bg-gray-700"} text-white flex flex-col items-center justify-center gap-1 text-xs`}>
                PAY TERM
              </Button> */}

              <Button
                onClick={() => {
                  if (selectedItemForDiscount) {
                    handleDiscountPopup("ITEM_DISCOUNT_POS");
                  }
                }}
                disabled={isProcessing || items.length === 0 || !currentOrder || !selectedItemForDiscount}
                className="w-full w-24 h-20 aspect-square bg-gray-600 hover:bg-gray-700 text-white flex flex-col items-center justify-center gap-1 text-xs">
                ITEM DISC
              </Button>

              <Popconfirm
                title="Remove Discount"
                description="Are you sure to remove discount?"
                onConfirm={handleRemoveDiscount}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  disabled={isProcessing || items.length === 0 || !currentOrder}
                  className="w-full w-24 h-20 aspect-square bg-gray-600 hover:bg-gray-700 text-white flex flex-col items-center justify-center gap-1 text-xs">
                  REMOVE DISC
                </Button>
              </Popconfirm>


              <Button
                onClick={() => {
                  handleCheckout({}, false, false, true);
                }}
                disabled={isProcessing || items.length === 0 || !currentOrder || !selectedTax}
                className="w-full w-24 h-20 aspect-square bg-primary hover:bg-primary text-white flex flex-col items-center justify-center gap-1 text-xs">
                {isProcessing ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    Processing...
                  </>
                ) : (
                  <>
                    <CreditCard className="h-4 w-4" />
                    HOLD ORDER
                  </>
                )}
              </Button>

              {userData?.RoleId !== AGENT && (
                <Popconfirm
                  title="Cancel Order"
                  description="Are you sure to cancel this order?"
                  onConfirm={() => {
                    if (onCancelOrder) {
                      onCancelOrder();
                    }
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    className="w-full w-24 h-20 aspect-square bg-red-600 hover:bg-gray-700 text-white flex flex-col items-center justify-center gap-1 text-xs">
                    CANCEL
                  </Button>
                </Popconfirm>
              )}

            </>)
          }

          {userData?.RoleId != AGENT &&
            <>
              <Button
                onClick={() => {
                  handleCheckout({}, true);
                }}
                disabled={isProcessing || items.length === 0 || !currentOrder}
                className="w-full w-24 h-20 aspect-square bg-primary hover:bg-primary text-white flex flex-col items-center justify-center gap-1 text-xs">
                <ReceiptText className="h-4 w-4" />
                KOT
              </Button>

              {/* Conditionally render the KotPrint component */}
              {dataForKotPrint && (
                <KotPrint
                  orderDetails={dataForKotPrint.orderDetails}
                  orderAddItems={dataForKotPrint.orderAddItems}
                  orderLessItems={dataForKotPrint.orderLessItems}
                  addHeading={dataForKotPrint.addHeading}
                  groupByDepartment={Boolean(dataForKotPrint.groupByDepartment)}
                  onComplete={() => setDataForKotPrint(null)}
                />
              )}

              <Popconfirm
                title="Clear All"
                description="Are you sure to clear all?"
                onConfirm={onClearAll}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  variant="destructive"
                  className="w-full w-24 h-20 aspect-square text-white flex flex-col items-center justify-center gap-1 text-xs">
                  <Trash2 className="h-4 w-4" />
                  CLEAR
                </Button>
              </Popconfirm>

              <Button
                onClick={() => handleDiscountPopup("BILL_DISCOUNT_POS")}
                disabled={isProcessing || items.length === 0 || !currentOrder || selectedItemForDiscount !== null}
                className="w-full w-24 h-20 aspect-square bg-gray-600 hover:bg-gray-700 text-white flex flex-col items-center justify-center gap-1 text-xs">
                DISCOUNT
              </Button>

              <Button
                onClick={() => setIsDeliveryChargesPopupOpen(true)}
                disabled={isProcessing || items.length === 0 || !currentOrder || currentOrder?.orderModeName?.toLowerCase() !== "delivery"}
                className={`w-full w-24 h-20 aspect-square ${deliveryCharges > 0 ? "bg-primary hover:bg-primary" : "bg-gray-600 hover:bg-gray-700"} text-white flex flex-col items-center justify-center gap-1 text-xs`}>
                DC
              </Button>

              <Button
                onClick={() => setIsPaymentTermsPopupOpen(true)}
                disabled={isProcessing || items.length === 0 || !currentOrder || !currentOrder?.paymentTerms || currentOrder?.paymentTerms?.length === 0}
                className={`w-full w-24 h-20 aspect-square ${selectedPaymentTerm ? "bg-primary hover:bg-primary" : "bg-gray-600 hover:bg-gray-700"} text-white flex flex-col items-center justify-center gap-1 text-xs`}>
                PAY TERM
              </Button>

              <Button
                onClick={() => {
                  if (selectedItemForDiscount) {
                    handleDiscountPopup("ITEM_DISCOUNT_POS");
                  }
                }}
                disabled={isProcessing || items.length === 0 || !currentOrder || !selectedItemForDiscount}
                className="w-full w-24 h-20 aspect-square bg-gray-600 hover:bg-gray-700 text-white flex flex-col items-center justify-center gap-1 text-xs">
                ITEM DISC
              </Button>

              <Popconfirm
                title="Remove Discount"
                description="Are you sure to remove discount?"
                onConfirm={handleRemoveDiscount}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  disabled={isProcessing || items.length === 0 || !currentOrder}
                  className="w-full w-24 h-20 aspect-square bg-gray-600 hover:bg-gray-700 text-white flex flex-col items-center justify-center gap-1 text-xs">
                  REMOVE DISC
                </Button>
              </Popconfirm>

              <Button
                onClick={() => handleBillPrint({ paymentModeLabel: "Cash", taxType: "cash" })}
                disabled={isProcessing || items.length === 0 || !currentOrder || !selectedTax}
                className="w-full w-24 h-20 aspect-square bg-emerald-600 hover:bg-emerald-700 text-white flex flex-col items-center justify-center gap-1 text-xs">
                BILL-CASH
              </Button>

              <Button
                onClick={() => handleBillPrint({ paymentModeLabel: "Card", taxType: "card" })}
                disabled={isProcessing || items.length === 0 || !currentOrder || !selectedTax}
                className="w-full w-24 h-20 aspect-square bg-blue-600 hover:bg-blue-700 text-white flex flex-col items-center justify-center gap-1 text-xs">
                BILL-CARD
              </Button>

              <Button
                onClick={() => handleBillPrint({ paymentModeLabel: "Cash & Card", taxType: "cash" })}
                disabled={isProcessing || items.length === 0 || !currentOrder || !selectedTax}
                className="w-full w-24 h-20 aspect-square bg-purple-600 hover:bg-purple-700 text-white flex flex-col items-center justify-center gap-1 text-xs">
                BILL-BOTH
              </Button>

              {DisplayCheckoutButton() &&
                <Button
                  onClick={() => {
                    handlePaymentButtonClick();
                  }}
                  disabled={isProcessing || items.length === 0 || !currentOrder || !selectedTax}
                  className="w-full w-24 h-20 aspect-square bg-primary hover:bg-primary text-white flex flex-col items-center justify-center gap-1 text-xs">
                  <CreditCard className="h-4 w-4" />
                  PAYMENT
                </Button>
              }
            </>
          }
        </div>
      </div>

      <OrderPayment
        open={isPaymentModalOpen}
        onOpenChange={setIsPaymentModalOpen}
        paymentDetail={
          {
            // subtotal: subtotalAfterDiscount,
            subtotal: subtotalBeforeDiscount,
            subtotalBeforeDiscount: subtotalBeforeDiscount,
            deliveryCharges: deliveryCharges,
            totalDiscount: totalDiscount,
            selectedTax: selectedTax,
            taxOptions: taxOptions,
            taxAmount: taxAmount,
            // total: total
            total: totalBill
          }
        }
        setSelectedTax={setSelectedTax}
        paymentMode={paymentModeList}
        handleCheckout={handleCheckout}
        phone_Number={currentOrder?.phoneNumber || ""}
        customer_Name={currentOrder?.customerName || ""}
        phoneId={currentOrder?.phoneId || null}
        customerId={currentOrder?.customerId || null}
        onBillDiscount={() => handleDiscountPopup("BILL_DISCOUNT_POS", true)}
        billDiscountDisabled={isProcessing || items.length === 0 || !currentOrder || selectedItemForDiscount !== null}
      />

      {/* Order Bill - Auto prints when Bill-Cash, Bill-Card, or Bill-Both buttons are clicked */}
      {billData && (
        <OrderBill
          ref={orderBillRef}
          orderDetails={billData.orderDetails}
          orderItems={billData.orderItems}
          onAfterPrint={() => {
            setBillCount(billCount + 1);
            setBillData(null);
            // Call API after successful print
            const orderMasterIdToUpdate = OrderMasterId || currentOrder?.OrderMasterId || currentOrderSnapshot?.OrderMasterId;
            if (orderMasterIdToUpdate) {
              updateTableWaiterRiderApi(orderMasterIdToUpdate, 9);
            }
          }}
        />
      )}

      {/* setCheckoutBillData(
          {
            orderDetails: current_Order,
            orderItems: orderKotItems,
            paymentDetails: obj?.tblOrderPayment,
            paymentDetailsInfo: obj?.info,
            paymentDetailsPartyAccountInfo: obj?.partyAccountInfo,
          }
        ); */}

      {/* Order Checkout Bill - Auto prints when payment is successful */}
      {checkoutBillData && (
        <OrderCheckoutBill
          ref={checkoutBillRef}
          orderDetails={checkoutBillData.orderDetails}
          orderItems={checkoutBillData.orderItems}
          paymentDetails={checkoutBillData.paymentDetails}
          onAfterPrint={() => {
            setCheckoutBillData(null);
          }}
          paymentDetailsInfo={checkoutBillData.paymentDetailsInfo}
          paymentDetailsPartyAccountInfo={checkoutBillData.paymentDetailsPartyAccountInfo}
        />
      )}

      {/* Auth Login Modal for item decrease authentication */}
      <AuthLoginModal
        setVisible={setVisibleAuthModal}
        visible={visibleAuthModal}
        featureName={featureName}
        onSuccess={handleAuthSuccess}
        menuName={menuName}
      />

      {/* Discount Popup */}
      <DiscountPopup
        open={isDiscountPopupOpen}
        onOpenChange={(open) => {
          setIsDiscountPopupOpen(open);
          // Clear selected item when popup closes
          if (!open && discountTypeFlex === "ITEM_DISCOUNT_POS") {
            setSelectedItemForDiscount(null);
          }
        }}
        items={discountTypeFlex === "ITEM_DISCOUNT_POS" && selectedItemForDiscount ? [selectedItemForDiscount] : items}
        currentOrder={currentOrder}
        onApplyDiscount={handleApplyDiscount}
        discountTypeFlex={discountTypeFlex}
      />

      {/* Delivery Charges Popup */}
      <DeliveryChargesPopup
        open={isDeliveryChargesPopupOpen}
        onOpenChange={setIsDeliveryChargesPopupOpen}
        currentDeliveryCharges={deliveryCharges}
        onApplyDeliveryCharges={handleApplyDeliveryCharges}
      />

      {/* Payment Terms Popup */}
      <PaymentTermsPopup
        open={isPaymentTermsPopupOpen}
        onOpenChange={(open) => {
          setIsPaymentTermsPopupOpen(open);
          // Reset the checkout flag if popup is closed without applying
          if (!open && shouldCheckoutAfterPaymentTerm) {
            setShouldCheckoutAfterPaymentTerm(false);
          }
        }}
        currentPaymentTerm={selectedPaymentTerm}
        paymentTerms={currentOrder?.paymentTerms || []}
        onApplyPaymentTerm={handleApplyPaymentTerm}
        shouldCheckoutAfterApply={shouldCheckoutAfterPaymentTerm}
        isRecalledOrder={isRecalledOrder}
      />

      {/* Special Instruction Dialog */}
      <SpecialInstructionDialog
        open={isSpecialInstructionDialogOpen}
        onOpenChange={setIsSpecialInstructionDialogOpen}
        item={selectedItemForInstruction}
        onSave={handleSaveSpecialInstruction}
      />

      {/* Product Detail Modal for editing deal items */}
      {isProductDetailModalOpen && selectedProductForEdit && currentOrder && (
        <ProductDetailModal
          product={(() => {
            // Reconstruct product object from item and currentOrder.Table
            const tableProduct = currentOrder.Table?.find(
              p => p.ProductId === selectedProductForEdit.ProductId ||
                p.ProductDetailId === selectedProductForEdit.ProductDetailId
            );

            if (tableProduct) {
              return {
                ...tableProduct,
                ProductPrice: selectedProductForEdit.basePrice || selectedProductForEdit.price,
                ProductName: selectedProductForEdit.name,
                ProductDescription: selectedProductForEdit.description,
                ProductImage: selectedProductForEdit.image,
                IsDeal: tableProduct.IsDeal || false
              };
            }

            // Fallback: construct from item data
            return {
              ProductId: selectedProductForEdit.ProductId,
              ProductDetailId: selectedProductForEdit.ProductDetailId,
              ProductName: selectedProductForEdit.name,
              ProductPrice: selectedProductForEdit.basePrice || selectedProductForEdit.price,
              ProductDescription: selectedProductForEdit.description || "",
              ProductImage: selectedProductForEdit.image || "",
              IsDeal: true, // Assume it's a deal if we're opening this modal
              GSTPercentage: selectedProductForEdit.GSTPercentage || 0,
              DepartmentId: selectedProductForEdit.DepartmentId || null,
              DepartmentName: selectedProductForEdit.DepartmentName || null
            };
          })()}
          onClose={() => {
            setIsProductDetailModalOpen(false);
            setSelectedProductForEdit(null);
          }}
          currentOrder={currentOrder}
          initialDealSelections={selectedProductForEdit.dealSelections || {}}
          initialOptionQuantities={selectedProductForEdit.optionQuantities || {}}
          initialQuantity={selectedProductForEdit.quantity || 1}
          initialSpecialInstructions={selectedProductForEdit.SpecialInstructions || ""}
          onAddProductDetailToOrder={(newOrderItemDetails) => {
            // Replace the old item with new items

            if (onUpdateItems) {
              const itemsArray = Array.isArray(newOrderItemDetails)
                ? newOrderItemDetails
                : [newOrderItemDetails];

              // Update items by removing old and adding new
              onUpdateItems((prevItems) => {
                const filteredItems = prevItems.filter(item => item.id !== selectedProductForEdit.id);
                return [...filteredItems, ...itemsArray];
              });
            } else if (onRemoveItem && selectedProductForEdit.id) {
              // Fallback: remove old item if onUpdateItems is not available
              onRemoveItem(selectedProductForEdit.id);
              // Note: New items would need to be added separately in this case
            }

            setIsProductDetailModalOpen(false);
            setSelectedProductForEdit(null);
          }}
        />
      )}

    </div>


  );

}